import { BarceloComponent } from "components-utils";

const AllBase = {
  bwdTabs: BarceloComponent({
    selector: ".bwd-tabs, .bwd-tabs-dl-id",
    path: "bwd/base/bwd-tabs/js/bwd-tabs",
  }),

  bwdTitle: BarceloComponent({
    selector: ".bwd-title, .bwd-title-dl-id",
    path: "bwd/base/bwd-title/js/bwd-title",
  }),

  bwdContainer: BarceloComponent({
    selector: ".bwd-container, .bwd-container-dl-id",
    path: "bwd/base/bwd-container/js/bwd-container",
  }),

  bwdGallery: BarceloComponent({
    selector: ".bwd-gallery, .bwd-gallery-dl-id",
    path: "bwd/base/bwd-gallery/js/bwd-gallery",
  }),

  bwdGalleryCard: BarceloComponent({
    selector: ".bwd-gallery-card, .bwd-gallery-card-dl-id",
    path: "bwd/base/bwd-gallery-card/js/bwd-gallery-card",
  }),

  bwdPackageComparator: BarceloComponent({
    selector: ".bwd-package-comparator, .bwd-package-comparator-dl-id",
    path: "bwd/base/bwd-package-comparator/js/bwd-package-comparator",
  }),
};

export default AllBase;
